<template>
  <div class="more">
    <div class="item" @click="jumpRouter('PersonalInfo')">
      <div class="title">账户与安全</div>
      <img class="arrow" :src="require('@/assets/images/icon_arrow_03.png')" alt="">
    </div>
    <div class="item" @click="jumpRouter('HelpCenter',1)">
      <div class="title">帮助中心</div>
      <img class="arrow" :src="require('@/assets/images/icon_arrow_03.png')" alt="">
    </div>
    <div class="item" @click="jumpRouter('Feedback')">
      <div class="title">意见反馈</div>
      <img class="arrow" :src="require('@/assets/images/icon_arrow_03.png')" alt="">
    </div>
    <div class="item" @click="jumpRouter('HelpCenter',2)">
      <div class="title">免责声明</div>
      <img class="arrow" :src="require('@/assets/images/icon_arrow_03.png')" alt="">
    </div>
    <div class="item" @click="jumpRouter('HelpCenter',3)">
      <div class="title">用户服务协议</div>
      <img class="arrow" :src="require('@/assets/images/icon_arrow_03.png')" alt="">
    </div>
    <div class="item" @click="jumpRouter('HelpCenter',4)">
      <div class="title">用户注册协议</div>
      <img class="arrow" :src="require('@/assets/images/icon_arrow_03.png')" alt="">
    </div>
    <div class="item" @click="jumpRouter('HelpCenter',5)">
      <div class="title">保护协议</div>
      <img class="arrow" :src="require('@/assets/images/icon_arrow_03.png')" alt="">
    </div>
    <div class="item" @click="jumpRouter('HelpCenter',6)">
      <div class="title">关于我们</div>
      <img class="arrow" :src="require('@/assets/images/icon_arrow_03.png')" alt="">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'More',
  computed: {
    ...mapGetters(['personInfo'])
  },
  methods: {
    jumpRouter (name, type) {
      this.$router.push({ name, params: { type } });
    }
  }
};
</script>

<style lang="less" scoped>
.more {
  padding: 0 28px;
  .item {
    width: 100%;
    padding: 36px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #EEEEEE;
    .title {
      font-size: 28px;
      color: #333444;
    }
    .arrow {
      width: 32px;
      height: 32px;
    }
  }
}
</style>